import * as React from "react";

const IconHeaderMobileBars: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" width="20" height="15" viewBox="0 0 20 15" fill="currentColor"><path fill="currentColor" d="M0,0 L19.25,0 L19.25,1.36363636 L0,1.36363636 L0,0 Z M0,6.81818182 L19.25,6.81818182 L19.25,8.18181818 L0,8.18181818 L0,6.81818182 Z M19.25,13.6363636 L19.25,15 L0,15 L0,13.6363636 L19.25,13.6363636 Z"/></svg>;
};

export default React.memo(IconHeaderMobileBars);
